import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import {
  getExerciseBlockValidationSchema,
  type ExerciseFormikType,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import {
  getMediaBlockValidationSchema,
  type MediaBlockFormikType,
} from "@/modules/sessions/sessionForm/blocks/mediaBlock/mediaBlockFormikTypes"
import {
  getAthleteNoteBlockValidationSchema,
  getCoachNoteBlockValidationSchema,
  type AthleteNoteFormikType,
  type CoachNoteFormikType,
} from "@/modules/sessions/sessionForm/blocks/noteBlock/noteFormikTypes"
import * as Yup from "yup"

export type SessionBlockInputKey = "content" | "type" | "url"

export type SessionBlockExerciseFormikType = {
  type: typeof SessionBlockType.SESSION_EXERCISE
  content: ExerciseFormikType
}
export type SessionBlockCoachNoteFormikType = {
  type: typeof SessionBlockType.COACH_NOTE
  content: CoachNoteFormikType
}
export type SessionBlockAthleteNoteFormikType = {
  type: typeof SessionBlockType.ATHLETE_NOTE
  content: AthleteNoteFormikType
}
export type SessionBlockMediasFormikType = {
  type: typeof SessionBlockType.MEDIAS
  content: MediaBlockFormikType
}

export type SessionBlockFormikType =
  | SessionBlockExerciseFormikType
  | SessionBlockCoachNoteFormikType
  | SessionBlockAthleteNoteFormikType
  | SessionBlockMediasFormikType

export function getSessionBlockValidationSchema() {
  return Yup.object().shape({
    type: Yup.string().oneOf(Object.values(SessionBlockType)),
    content: Yup.object().when("type", (type) => {
      return type[0] === SessionBlockType.SESSION_EXERCISE
        ? getExerciseBlockValidationSchema()
        : type[0] === SessionBlockType.COACH_NOTE
          ? getCoachNoteBlockValidationSchema()
          : type[0] === SessionBlockType.ATHLETE_NOTE
            ? getAthleteNoteBlockValidationSchema()
            : getMediaBlockValidationSchema()
    }),
  })
}
